import * as React from 'react';
import { Accordion } from 'damco-components';
import PropertyDisplay from 'components/cost-revenue/PropertyDisplay';
import Table from 'components/data-table/Table';
import { IPaternList, IPattern } from 'views/job-costing/utils/models';
import { formatData, sortElementByKey } from 'utilities/util';
import { redirectToViewInvoice } from 'utilities/route-utils';

export interface IProps {
    link: (url: string) => void;
    organisation: IPaternList[],
    jobIdDetails: IPaternList[],
    locations: IPaternList[],
    cargo: IPaternList[],
    bookings: IPattern,
    equipments: IPattern,
    fcr: IPattern,
    clr: IPattern,
    equipmentTransportShipments: IPattern,
    voyages: IPattern,
    customerInvoice: IPattern,
    isExtraDocumentFeatureEnabled: boolean
}
class CblDetails extends React.Component<IProps> {
    public createLink = (data: any, target: string) => {
        switch (target) {
            case 'booking':
                this.props.link(String(`/job-costing/booking/${data!.id}`))
                break;
            case 'fcr':
                this.props.link(String(`/job-costing/documents/${data!.id}`))
                break;
            case 'cbl':
                this.props.link(String(`/job-costing/cbls/${data!.id}`))
                break;
            case 'equipments':
                this.props.link(String(`/job-costing/equipments/${data!.equipmentId}`))
                break;
            case 'invoices':
                redirectToViewInvoice('origin', data!.internalBillingNo);
                break;
            case 'ets':
                this.props.link(String(`/job-costing/ets/${data!.equipmentTransportShipmentId}/`))
                break;
        }
    }
    public render() {
        const newEquipmentTransport = this.props.equipmentTransportShipments;
        newEquipmentTransport.data = newEquipmentTransport.data.filter(equipment => !equipment.isCancelled)
        if (newEquipmentTransport.data && newEquipmentTransport.data.length) {
            newEquipmentTransport.data = newEquipmentTransport.data.map((data: any) => {
                data.id = data.equipmentTransportShipmentId
                if (data.anyIssoSent) {
                    data.anyIssoSent = data.anyIssoSent.toString()
                }
                data.equipmentSealNumber = data.sealNumber
                return data
            })
        }
        const extraDocsETS = JSON.parse(JSON.stringify(newEquipmentTransport));
        if (extraDocsETS.data && extraDocsETS.data.length) {
            extraDocsETS.data = extraDocsETS.data.filter((val: any) => val.equipmentTransportShipmentDocumentNumber && (val.equipmentTransportShipmentDocumentNumber.startsWith('IED')));
        }
        const exceptExtraDocsETS = JSON.parse(JSON.stringify(newEquipmentTransport));
        if (exceptExtraDocsETS.data && exceptExtraDocsETS.data.length) {
            exceptExtraDocsETS.data = exceptExtraDocsETS.data.filter((val: any) => val.equipmentTransportShipmentDocumentNumber && !val.equipmentTransportShipmentDocumentNumber.startsWith('IED'));
        }
        const newEq: any = { ...this.props.equipments }
        if (newEq.data && newEq.data.length) {
            newEq.data = newEq.data.map((data: any) => {
                data.etOnEssoVolumeFactor = data.essoEtOnCblVolumeFactor
                return data
            })
        }
        const newCLR = { ...this.props.clr };
        if (newCLR && newCLR.data) {
            newCLR.data = newCLR.data.map((data: any) => {
                const newData = formatData([data])
                return newData[0]
            })
        }
        const customerData = this.props.customerInvoice;
        customerData.data = sortElementByKey(customerData.data, 'createdDate', true, 'date');

        const extraDocs = JSON.parse(JSON.stringify(this.props.fcr));
        if (extraDocs.data && extraDocs.data.length) {
            extraDocs.data = extraDocs.data.filter((val: any) => val.originalDocumentNumber && val.originalDocumentNumber.startsWith('EED'));
        }
        const exceptExtraDocs = JSON.parse(JSON.stringify(this.props.fcr));
        if (exceptExtraDocs.data && exceptExtraDocs.data.length) {
            exceptExtraDocs.data = exceptExtraDocs.data.filter((val: any) => val.originalDocumentNumber && !val.originalDocumentNumber.startsWith('EED'));
        }
		this.props.bookings?.data?.forEach(data => {
			data.isTransferred = data.isTransferred === true || data.isTransferred === 'true' || data.isTransferred === 'Yes' ? 'Yes' : 'No';
		});

        return (
            <div className="padding-top-large padding-bottom-large">
                <Accordion title={'Organisation'}>
                    <PropertyDisplay data={[...this.props.organisation]} id="organisation" />
                </Accordion>
                <Accordion title={'Locations'}>
                    <PropertyDisplay data={[...this.props.locations]} id="locations" />
                </Accordion>
                <Accordion title={'Cargo details'}>
                    <PropertyDisplay data={[...this.props.cargo]} id="cargo" />
                </Accordion>
                <Accordion title={'Job ID Details'}>
                    <PropertyDisplay data={[...this.props.jobIdDetails]} id="jobIdDetails" />
                </Accordion>
                <Accordion title={'clr'}>
                    <Table {...newCLR}
                        id="cbls-details-clr"
                        hasTotal={true}
                    />
                </Accordion>
                <Accordion title={'equipments'}>
                    <Table {...this.props.equipments}
                        id="cbls-details-equipments"
                        hasTotal={true}
                        isCBL={true}
                        linkAction={(row: any) => { this.createLink(row, 'equipments') }} />
                </Accordion>
                <Accordion title={'Booking'}>
                    <Table
                        {...this.props.bookings}
                        hasTotal={true}
                        id="cbls-details-bookings"
                        linkAction={(row: any) => { this.createLink(row, 'booking') }} />
                </Accordion>
                {!this.props.isExtraDocumentFeatureEnabled &&
                    <Accordion title={'fcr'}>
                        <Table {...this.props.fcr} id="cbls-details-documents"
                            hasTotal={true}
                            linkAction={(row: any) => { this.createLink(row, 'fcr') }} />
                    </Accordion>
                }
                {this.props.isExtraDocumentFeatureEnabled &&
                    <Accordion title={'Document'}>
                        <Table {...exceptExtraDocs}
                            id="cbls-details-documents"
                            hasTotal={true}
                            linkAction={(row: any) => { this.createLink(row, 'fcr') }} />
                    </Accordion>
                }
                {this.props.isExtraDocumentFeatureEnabled &&
                    extraDocs.data &&
                    extraDocs.data.length > 0 &&
                    <Accordion title={'Export Extra Document'}>
                        <Table {...extraDocs}
                            id="cbls-details-extra-documents"
                            hasTotal={true}
                            linkAction={(row: any) => {this.createLink(row, 'fcr') }} />
                    </Accordion>
                }
                {!this.props.isExtraDocumentFeatureEnabled &&
                    <Accordion title={'EQUIPMENT TRANSPORT SHIPMENTS'}>
                        <Table {...newEquipmentTransport} id="cbls-details-equipmentTransportShipments"
                            hasTotal={true}
                            linkAction={(row: any) => { this.createLink(row, 'ets') }} />
                    </Accordion>
                }
                {this.props.isExtraDocumentFeatureEnabled &&
                    <Accordion title={'EQUIPMENT TRANSPORT SHIPMENTS'}>
                        <Table {...exceptExtraDocsETS} id="cbls-details-equipmentTransportShipments"
                            hasTotal={true}
                            linkAction={(row: any) => { this.createLink(row, 'ets') }} />
                    </Accordion>
                }
                {this.props.isExtraDocumentFeatureEnabled &&
                    extraDocsETS.data &&
                    extraDocsETS.data.length > 0 &&
                    <Accordion title={'Import Extra Document'}>
                        <Table {...extraDocsETS} id="cbls-details-extraEquipmentTransportShipments"
                            hasTotal={true}
                            linkAction={(row: any) => { this.createLink(row, 'ets') }} />
                    </Accordion>
                }
                <Accordion title={'VESSEL/VOYAGE'}>
                    <Table {...this.props.voyages}
                        id="cbls-details-voyages"
                    />
                </Accordion>
                <Accordion title={'Customer invoice'}>
                    <Table {...this.props.customerInvoice} id="cbls-details-customerInvoices"
                        linkAction={(row: any) => { this.createLink(row, 'invoices') }} />
                </Accordion>
            </div>
        );
    }
}

export default CblDetails;